export default class SplitImageSlider {
    constructor(container) {
        this.container = container;
        this.sides = {
            left: container.querySelector('.split-image-slider__side--left'),
            right: container.querySelector('.split-image-slider__side--right')
        };

        const raw = container.dataset.images || '[]';
        this.images = JSON.parse(raw);

        this.indexLeft = 0;
        this.indexRight = 1;
        this.interval = null;

        if (this.images.length < 2) return;

        this.initSides();
        this.startSlider();
    }

    initSides() {
        ['left', 'right'].forEach((sideName, i) => {
            const side = this.sides[sideName];
            const imgA = side.querySelector('img');
            imgA.classList.add('active');

            const imgB = imgA.cloneNode();
            imgB.classList.remove('active');
            side.appendChild(imgB);

            side.imgA = imgA;
            side.imgB = imgB;
            side.current = imgA;
            side.next = imgB;
        });

        this.preloadAll();
    }

    preloadAll() {
        this.images.forEach(({ url }) => {
            const img = new Image();
            img.src = url;
        });
    }

    startSlider() {
        this.lastUpdatedSide = Math.random() > 0.5 ? 'left' : 'right';

        this.interval = setInterval(() => {
            if (this.lastUpdatedSide === 'right') {
                this.indexLeft = this.getNextIndex(this.indexLeft, this.indexRight);
                this.crossfade(this.sides.left, this.indexLeft);
                this.lastUpdatedSide = 'left';
            } else {
                this.indexRight = this.getNextIndex(this.indexRight, this.indexLeft);
                this.crossfade(this.sides.right, this.indexRight);
                this.lastUpdatedSide = 'right';
            }
        }, 3000);
    }


    getNextIndex(currentIndex, otherIndex) {
        const availableIndexes = this.images
            .map((_, i) => i)
            .filter(i => i !== currentIndex && i !== otherIndex);

        if (availableIndexes.length === 0) return currentIndex;

        return availableIndexes[Math.floor(Math.random() * availableIndexes.length)];
    }


    crossfade(side, imageIndex) {
        const { url, alt } = this.images[imageIndex];
        const nextImg = side.next;

        nextImg.src = url;
        nextImg.alt = alt || '';

        nextImg.classList.remove('active');

        void nextImg.offsetWidth;

        nextImg.classList.add('active');

        setTimeout(() => {
            side.current.classList.remove('active');
            [side.current, side.next] = [side.next, side.current];
        }, 1000);
    }

}
